import React, { useState } from "react";
import { motion } from "framer-motion";
import { X, Maximize2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import SectionTitle from "./SectionTitle";
import { GALLERY } from "../data/content";

const spans = [
  "md:col-span-2 md:row-span-2",
  "",
  "",
  "md:col-span-2",
  "",
  "md:row-span-2",
  "",
  "",
];

export const Gallery = () => {
  const [active, setActive] = useState(null);

  return (
    <section id="galerie" className="section bg-gradient-to-b from-[#050505] via-[#08060f] to-[#050505] py-28">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <SectionTitle kicker="Galerie" title="Lumières & foules" testid="gallery-title" />

        <div className="grid auto-rows-[180px] grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {GALLERY.map((src, i) => (
            <motion.button
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.08 }}
              onClick={() => setActive(src)}
              className={`group relative overflow-hidden rounded-2xl ${spans[i] || ""}`}
            >
              <img src={src} alt={`Oli.Vero ${i + 1}`} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
              <span className="absolute right-3 top-3 flex h-9 w-9 items-center justify-center rounded-full glass opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <Maximize2 size={16} className="text-white" />
              </span>
            </motion.button>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-5xl border-white/10 bg-black/95 p-2" data-testid="gallery-lightbox">
          <DialogTitle className="sr-only">Photo Oli.Vero</DialogTitle>
          {active && <img src={active} alt="Oli.Vero" className="max-h-[85vh] w-full rounded-lg object-contain" />}
        </DialogContent>
      </Dialog>
    </section>
  );
};

export default Gallery;
